import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { useCurrentUser } from "../../slices/auth/hooks";
import { logoutUser } from "../../slices/thunks";
import { useNavigate } from "react-router-dom";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useCurrentUser();
  const globalTheme = useSelector(state => state.Theme);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.clear();
    navigate("/login");
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-1 header-item topbar-user p-0"
        style={{ borderRadius: "50%" }}
      >
        <DropdownToggle
          tag="span"
          // type="button"
          className="btn p-1 "
          style={{ borderRadius: "50%" }}
        >
          <i className="mdi mdi-account-circle fs-1 text-dark"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end mt-n1">
          <h6 className="dropdown-header">Welcome {user?.firstName}!</h6>
          <DropdownItem className="p-0">
            <Link
              to={process.env.PUBLIC_URL + "/profile"}
              className="dropdown-item"
            >
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Profile</span>
            </Link>
          </DropdownItem>

          {!globalTheme?.uiCustomization?.hideResourcesTab && (
            <DropdownItem className="p-0">
              <Link to={"/resources"} className="dropdown-item">
                <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{" "}
                <span className="align-middle">Help</span>
              </Link>
            </DropdownItem>
          )}
          <div className="dropdown-divider"></div>
          <DropdownItem className="p-0">
            <Link to={process.env.PUBLIC_URL + "#"} className="dropdown-item">
              {/* <span
                                className="badge bg-soft-success text-success mt-1 float-end">New</span> */}
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Settings</span>
            </Link>
          </DropdownItem>

          <DropdownItem className="p-0">
            <Link to="#" onClick={handleLogout} className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
